<template>
  <div class="PersonVacationListWeb">
    <v-data-table
      dense
      :headers="headers"
      :items="list"
      :items-per-page="5"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
    >
      <!-- Header: Select All Checkbox -->
      <template v-slot:header.select="{}">
        <v-checkbox
          dense
          hide-details
          :input-value="areVisibleItemsAllSelected"
          @change="toggleSelectCurrentPage"
        />
      </template>

      <!-- Body: Display rows -->
      <template v-slot:body="{ items }">
        <tbody>
          <!-- Update visibleItems array to current page -->
          <template v-if="updateVisibleItems(items)" />
          <tr v-for="item in items" :key="item.Id"></tr>
          <tr
            v-for="item in items"
            :key="item.Id"
            @click="handleClick(item)"
            style="cursor: pointer"
          >
            <td v-if="show">
              <v-checkbox
                dense
                hide-details
                v-model="item.select"
                @click.stop
              />
            </td>
            <td>{{ item.Perno }}</td>
            <td>{{ item.PersonName }}</td>
            <td>{{ item.Name }}</td>
            <td>{{ item.BeginDate }}</td>
            <td>{{ item.BeginTime }}</td>
            <td>{{ item.EndDate }}</td>
            <td>{{ item.EndTime }}</td>
            <td>{{ item.StatusType }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "VacationManagementListWeb",
  emits: ["onClickVacation"],
  props: {
    list: {
      type: Array,
      required: true,
    },
    approved: Boolean,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: true,
      visibleItems: [],
      headers: [
        { text: this.$t(""), value: "select", sortable: false }, // select checkbox
        { text: this.$t("card-no"), value: "Perno" },
        { text: this.$t("person-name"), value: "PersonName" },
        { text: this.$t("vacationType"), value: "Name" },
        { text: this.$t("BeginDate"), value: "BeginDate" },
        { text: this.$t("BeginTime"), value: "BeginTime" },
        { text: this.$t("EndDate"), value: "EndDate" },
        { text: this.$t("EndTime"), value: "EndTime" },
        { text: this.$t("status"), value: "StatusType" },
      ],
    };
  },
  computed: {
    areVisibleItemsAllSelected() {
      return (
        this.visibleItems.length > 0 &&
        this.visibleItems.every((item) => item.select === true)
      );
    },
  },
  methods: {
    updateVisibleItems(items) {
      // Ensure all visible items have `select` property
      items.forEach((item) => {
        if (item.select === undefined) this.$set(item, "select", false);
      });
      this.visibleItems = items;
      return true;
    },
    toggleSelectCurrentPage(value) {
      // Clear selection on all first
      this.list.forEach((item) => this.$set(item, "select", false));

      // Then only select items on the current page
      if (value) {
        this.visibleItems.forEach((item) => this.$set(item, "select", true));
      }
    },
    handleClick(item) {
      this.$emit("onClickVacation", item);
    },
    checkApproved() {
      if (this.approved) {
        this.show = false;
        this.headers = this.headers.filter((h) => h.value !== "select");
      }
    },
  },
  mounted() {
    this.checkApproved();
  },
};
</script>
